const parameters = [
  {
    name: 'Fast EMA',
    values: [12, 14, 11, 13, 12, 15, 13, 12],
    mean: 12.8,
    cv: 9.8,
    stability: 'high',
    color: '#22c55e',
  },
  {
    name: 'Slow EMA',
    values: [26, 28, 24, 27, 30, 25, 26, 28],
    mean: 26.8,
    cv: 7.1,
    stability: 'high',
    color: '#22c55e',
  },
  {
    name: 'RSI Period',
    values: [14, 18, 12, 22, 16, 20, 14, 19],
    mean: 16.9,
    cv: 21.4,
    stability: 'moderate',
    color: '#f59e0b',
  },
];

function ParamRow({ param }: { param: typeof parameters[0] }) {
  const min = Math.min(...param.values);
  const max = Math.max(...param.values);
  const range = max - min || 1;

  return (
    <div style={{ marginBottom: '0.65rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.3rem' }}>
        <span style={{ fontSize: '0.7rem', fontWeight: 600, color: '#e2e8f0' }}>{param.name}</span>
        <span style={{ fontSize: '0.6rem', color: param.color }}>
          CV {param.cv}% ({param.stability})
        </span>
      </div>
      <div style={{ position: 'relative', height: 24, background: '#1e293b', borderRadius: 4, overflow: 'hidden' }}>
        {/* Range band */}
        <div style={{
          position: 'absolute',
          left: `${((min - min + 2) / (range + 4)) * 100}%`,
          width: `${(range / (range + 4)) * 100}%`,
          height: '100%',
          background: `${param.color}18`,
          borderLeft: `2px solid ${param.color}40`,
          borderRight: `2px solid ${param.color}40`,
        }} />
        {/* Individual values */}
        {param.values.map((v, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              left: `${((v - min + 2) / (range + 4)) * 100}%`,
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: param.color,
              opacity: 0.7 + (i / param.values.length) * 0.3,
            }}
          />
        ))}
        {/* Mean marker */}
        <div style={{
          position: 'absolute',
          left: `${((param.mean - min + 2) / (range + 4)) * 100}%`,
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: 10,
          height: 10,
          borderRadius: '50%',
          border: `2px solid ${param.color}`,
          background: 'transparent',
        }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.55rem', color: '#64748b', marginTop: 2 }}>
        <span>Min: {min}</span>
        <span>Mean: {param.mean}</span>
        <span>Max: {max}</span>
      </div>
    </div>
  );
}

export default function ParameterStabilityWFAMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Parameter Stability Across Windows</div>
      <div className="platform-mock-body">
        {parameters.map((p) => (
          <ParamRow key={p.name} param={p} />
        ))}
        <div style={{
          marginTop: '0.5rem',
          padding: '0.4rem 0.6rem',
          background: '#0f172a',
          borderRadius: 4,
          fontSize: '0.6rem',
          color: '#94a3b8',
          textAlign: 'center',
        }}>
          Overall stability score: <span style={{ color: '#22c55e', fontWeight: 600 }}>78 / 100</span> — EMA parameters are stable, RSI shows moderate drift
        </div>
      </div>
      <div className="platform-mock-caption">Each dot is one window's optimal value. Tight clusters (low CV) indicate real market signals.</div>
    </div>
  );
}
